
import React from "react";
import "./footer.css";

const quicklinks = [
    {
        path: 'marketingbrandstorm@gmail.com',
        display: <span><i class="ri-mail-fill"></i> Email</span>,
    },
    {
        path: 'https://twitter.com/BrandstormAd?t=2s8QbP5FVcU40SQYir7fg&s=09',
        display: <span><i class="ri-twitter-fill"></i> Twitter</span>,
    },
    {
        path: 'https://instagram.com/brandstorm_marketing?igshid=YmMyMTA2M2Y=',
        display: <span><i class="ri-instagram-fill"></i> Instagram</span>,
    },
    {
        path: 'https://www.linkedin.com/company/brandstorm-marketing-ghana/',
        display: <span><i class="ri-linkedin-box-fill"></i> LinkedIn</span>,
    },
];



const Footer = () => {
    const year = new Date().getFullYear()
    return  <footer className="footer">
       <div className="container">
        <div className="footer_wrapper">
            <div className="footer_logo">
                <h2>Our Social media handles</h2>
                <p className="description">Advertise with us</p>

                <p className="small_text description">We use upper edge methods to help with whatever you might require for graphic design, video editing, web development, and 
                content and copywriting</p>
            </div>

            <div className="footer_quick-links">
                <h3 className="quick_links-title">You can contact us</h3>
                <ul className="quick_links">
                    {
                        quicklinks.map((item, index) =>
                        (
                            <li className="quick_link-item" key={index}><a href={item.path}>{item.display}</a></li>
                        ))
                    }
                </ul>
            </div>
        </div>

        <p className="copyright">Copyright {year}, developed by Abakah Alexander Abeiku
        All rights reserved. {" "} </p>
        </div> 
    </footer>
    
};

export default Footer;